var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLineSpacing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "cyan",
    d: "m5.18731,5.005c0.45,0 0.67,-0.54 0.35,-0.85l-2.29,-2.3c-0.2,-0.2 -0.51,-0.2 -0.71,0l-2.29,2.3c-0.31,0.31 -0.09,0.85 0.36,0.85l1.29,0l0,10l-1.29,0c-0.45,0 -0.67,0.54 -0.35,0.85l2.29,2.29c0.2,0.2 0.51,0.2 0.71,0l2.29,-2.29c0.31,-0.31 0.09,-0.85 -0.36,-0.85l-1.29,0l0,-10l1.29,0zm3.71,0l10,0c0.55,0 1,-0.45 1,-1s-0.45,-1 -1,-1l-10,0c-0.55,0 -1,0.45 -1,1s0.45,1 1,1zm10,10l-10,0c-0.55,0 -1,0.45 -1,1s0.45,1 1,1l10,0c0.55,0 1,-0.45 1,-1s-0.45,-1 -1,-1zm0,-6l-10,0c-0.55,0 -1,0.45 -1,1s0.45,1 1,1l10,0c0.55,0 1,-0.45 1,-1s-0.45,-1 -1,-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineSpacing);
export default __webpack_public_path__ + "static/media/icon-line-spacing.fbd6c77b9a427a6d83565b299f71a645.svg";
export { ForwardRef as ReactComponent };